<template>
  <div class="footer footer navbar-fixed-bottom">
    <footer class="page-footer font-small blue">
      <!-- Copyright -->
      <div class="footer-copyright text-center py-3">
        © 2019 Copyright of
        <img
          src="../assets/Logo Kanbanesia.png"
          alt
          srcset
          class="ml-3"
          style="height: 80px"
        />
        <br />by Muhamad Fadhil Surya Putra
      </div>
      <!-- Copyright -->
    </footer>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>